import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './servicios/store';
import Inicio from './vistas/Inicio';
import AdminPanel from './vistas/AdminPanel';
import EstudianteHome from './vistas/EstudianteHome';
import ConsultaCertificado from './vistas/ConsultaCertificado';
import CuentaDesactivada from './vistas/CuentaDesactivada';
import Loader from './componentes/Loader';
import 'bootstrap/dist/css/bootstrap.min.css';
import Terminos from './componentes/Terminos';
import PreguntasFrecuentes from './componentes/PreguntasFrecuentes';
import './App.css';
import RutaProtegida from './servicios/RutaProtegida';

// Configuración de entradas premium
const entradasPremium = {
  Entrada01: lazy(() => import('./pages/Entrada01')),
  // Añadir nuevas entradas aquí
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/inicio" element={<Inicio />} />
          <Route path="/terminos" element={<Terminos />} />
          <Route path="/preguntas-frecuentes" element={<PreguntasFrecuentes />} />
          <Route path="/verificar-certificado/:cedula" element={<ConsultaCertificado />} />
          <Route path="/cuenta-desactivada" element={<CuentaDesactivada />} />
          
          {/* Rutas premium dinámicas */}
          {Object.entries(entradasPremium).map(([nombre, Componente]) => (
            <Route 
              key={nombre} 
              path={`/contenido/${nombre}`} 
              element={
                <RutaProtegida rolesPermitidos={['usuario', 'superadmin']}>
                  <Suspense fallback={<Loader />}>
                    <Componente />
                  </Suspense>
                </RutaProtegida>
              }
            />
          ))}

          <Route path="/" element={<Navigate to="/inicio" replace />} />

          <Route path="/admin-panel" element={
            <RutaProtegida rolesPermitidos={['superadmin']}>
              <AdminPanel />
            </RutaProtegida>
          }/>

          <Route path="/estudiante-home" element={
            <RutaProtegida rolesPermitidos={['usuario']}>
              <EstudianteHome />
            </RutaProtegida>
          }/>

          <Route path="*" element={
            <div className="fullscreen-loader">
              <Loader />
              <Navigate to="/inicio" replace />
            </div>
          }/>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;